import * as types from '../constants/ActionTypes';
import ConfigService from "../services/config.service";
import { handleAPIError } from "./common.actions";

const setAPIState = apiState => ({
  type: types.SET_CONFIG_API_STATE,
  apiState
});

const receiveConfig = config => ({
  type: types.RECEIVE_CONFIG,
  config
});

export const getConfig = () => dispatch => {
  dispatch(setAPIState("get"));
  return ConfigService.getConfig().then(
    response => {
      dispatch(receiveConfig(response.data));
    },
    handleAPIError(dispatch));
};

export const saveConfig = values => dispatch => {
  dispatch(setAPIState("save"));
  return ConfigService.saveConfig(values).then(
    response => {
      // Server returns the refreshed (masked) config — use it as the new state.
      dispatch(receiveConfig(response.data));
    },
    handleAPIError(dispatch));
};

// Ask the MCP server to restart its listener, then refresh status after it rebinds.
export const restartMcp = () => dispatch => {
  return ConfigService.restartMcp().then(
    () => {
      setTimeout(() => dispatch(getConfig()), 7000);
    },
    handleAPIError(dispatch));
};
